"use client";

import { forwardRef, type InputHTMLAttributes } from "react";
import { Choice } from "./Choice";

export type RadioProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type">;

export const Radio = forwardRef<HTMLInputElement, RadioProps>(function Radio(props, ref) {
  return <Choice {...props} ref={ref} choiceType="radio" />;
});
